import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { Navbar } from './components/Navbar';
import { Footer } from './components/Footer';
import { WhatsAppButton } from './components/WhatsAppButton';
import { HomePage } from './pages/HomePage';
import { Caminata5KPage } from './pages/Caminata5KPage';
import { DeportesPage } from './pages/DeportesPage';
import { ExpositoresPage } from './pages/ExpositoresPage';
import { PatrocinadoresPage } from './pages/PatrocinadoresPage';
import { MuroPage } from './pages/MuroPage';
import { GraciasPage } from './pages/GraciasPage';
import { SubirDocumentoPage } from './pages/SubirDocumentoPage';
import { TerminosPage } from './pages/TerminosPage';
import { NovoeiaModal } from './components/NovoeiaModal';
import { DiverxoModal } from './components/DiverxoModal';
export function App() {
  return <div className="min-h-screen bg-white overflow-x-hidden" data-id="element-0">
      <Navbar data-id="element-1" />
      <main data-id="element-2">
        <Routes data-id="element-3">
          <Route path="/" element={<HomePage data-id="element-5" />} data-id="element-4" />
          <Route path="/caminata-canina" element={<Caminata5KPage data-id="element-7" />} data-id="element-6" />
          {/* Redirect legacy path so old links keep working */}
          <Route path="/caminata-5k" element={<Navigate to="/caminata-canina" replace data-id="element-9" />} data-id="element-8" />
          <Route path="/deportes" element={<DeportesPage data-id="element-11" />} data-id="element-10" />
          <Route path="/expositores" element={<ExpositoresPage data-id="element-13" />} data-id="element-12" />
          <Route path="/patrocinadores" element={<PatrocinadoresPage data-id="element-15" />} data-id="element-14" />
          <Route path="/muro" element={<MuroPage data-id="element-17" />} data-id="element-16" />
          <Route path="/gracias" element={<GraciasPage data-id="element-19" />} data-id="element-18" />
          <Route path="/subir-documento" element={<SubirDocumentoPage data-id="element-21" />} data-id="element-20" />
          <Route path="/terminos" element={<TerminosPage data-id="element-23" />} data-id="element-22" />
        </Routes>
      </main>
      <Footer data-id="element-24" />
      <WhatsAppButton data-id="element-25" />
      <NovoeiaModal data-id="element-26" />
      <DiverxoModal data-id="element-27" />
    </div>;
}